import { DateTime } from 'luxon';
import { ordinalSuffixOf } from './functional-helpers';

const YEAR_2000 = 2000;
const YEAR_1900 = 1900;

// Output May 7th 2020
export function formatDateWithSuffixedDay(date: Date) {
  return `${DateTime.fromJSDate(date).toFormat('LLLL')} ${ordinalSuffixOf(
    date.getDate(),
  )} ${DateTime.fromJSDate(date).toFormat('yyyy')}`;
}

export function getTwelveAMOfToday() {
  const today = new Date();
  today.setHours(0);
  today.setMinutes(0);
  today.setMilliseconds(0);

  return today;
}

export function getAgeYearsFromBirthDate(birthDate: Date, todayDate: Date) {
  const todayDateTime = DateTime.fromJSDate(todayDate);
  const birthDateTime = DateTime.fromJSDate(birthDate);
  const diffTime = todayDateTime.diff(birthDateTime, ['years']);
  return Math.floor(diffTime.years);
}

// precondition: idNumber parameter is valid ID number
export function getDateOfBirthFromIdNumber(idNumber: string) {
  const currentDate = new Date();
  const yearTwoDigit = parseInt(idNumber.substring(0, 2));
  const month = parseInt(idNumber.substring(2, 4)) - 1;
  const day = parseInt(idNumber.substring(4, 6));

  // assume two digit year is in past - won't work for persons 100 years of age or older
  const yearFourDigitsAfterYearTwoThousand = YEAR_2000 + yearTwoDigit;
  const yearFourDigitsBeforeYearTwoThousand = YEAR_1900 + yearTwoDigit;
  const yearFourDigit =
    yearFourDigitsAfterYearTwoThousand > currentDate.getFullYear()
      ? yearFourDigitsBeforeYearTwoThousand
      : yearFourDigitsAfterYearTwoThousand;

  return new Date(yearFourDigit, month, day);
}
